// extracted by mini-css-extract-plugin
export default {"recos":"D4-z","productCardOverride":"E4-z","rowHasBadge":"F4-z"};